import { Deserializable } from '../../protocols/deserializable';

export class EmployerCRANumberInUseResponse implements Deserializable {
  craNumberInUse!: boolean;

  public onDeserialize() {}
}
